export enum ConnectionType {
  WIFI = 'wifi',
  ETHERNET = 'ethernet'
}

export const searchableDeviceAttributes: string[] = [
  'deviceName',
  'deviceLocationName',
  'deviceType',
  'deviceModel',
  'deviceSerial',
  'deviceSubscription',
  'access',
  'lastUpdate'
]
